import { useEffect, useState } from "react";
import { listPreview } from "@veto/domain";
import { ModalShell } from "./ModalShell";
import type { MessageHit } from "./ConversationListPane";

/**
 * Starred messages (phone parity): one chat's, or every chat's. Tapping one opens its chat at
 * that message. Stars are local to this device.
 */
export function StarredModal({
  conversationId,
  load,
  onClose,
  onOpen,
}: {
  /** null: every chat. */
  conversationId: string | null;
  load: (conversationId: string | null) => Promise<MessageHit[]>;
  onClose: () => void;
  onOpen: (hit: MessageHit) => void;
}) {
  const [hits, setHits] = useState<MessageHit[] | null>(null);
  useEffect(() => {
    let live = true;
    void load(conversationId).then((h) => live && setHits(h));
    return () => {
      live = false;
    };
  }, [conversationId, load]);

  return (
    <ModalShell
      title="Starred messages"
      ariaLabel="Starred messages"
      onClose={onClose}
      size="sheet"
      className="starred-modal"
    >
      {hits === null && <p className="muted">Loading…</p>}
      {hits?.length === 0 && (
        <p className="muted">
          No starred messages yet. Long-press a message (or right-click) and choose Star to keep it
          here.
        </p>
      )}
      <div className="forward-list">
        {hits?.map((h) => (
          <button key={h.eventId} type="button" className="starred-row" onClick={() => onOpen(h)}>
            <span className="starred-head">
              {conversationId === null && <strong>{h.title}</strong>}
              <span className="muted text-sm">{new Date(h.createdAt).toLocaleString()}</span>
            </span>
            <span className="starred-body">{listPreview(h.body) || h.body}</span>
          </button>
        ))}
      </div>
    </ModalShell>
  );
}
